export default __webpack_public_path__ + "static/media/SUN.344aace3.png";